import moment from "moment";

export function numberOfDaysInRange(startDay: string, endDay: string): number {
  const end = moment(endDay);
  const start = moment(startDay);

  return end.diff(start, "days") + 1;
}
